<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1> Sports Events</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
  </div>
</section>
<section class="section section-sm sport-event  section-banner-bg-1">
  <div class="container">
    <div class="row text-justify">
      <div class="col-md-12">
        <p>
          The health and well-being of Students and Society, and their levels of participation in sport and
          physical activity, is of growing concern and it is an area where GHRSCF will play vital role. GHRSCF
          recognises that participation in physical activity as
          well as indoor and outdoor sports can have many positive benefits on the experience, assisting
          transitions, developing technical skills, promoting excellence and developing leadership skills.
          Regardless of the level of participation
          in physical activity there is an impact on the physical and mental health of students.
        </p>
        <p>
          GHRSCF recognises the importance of physical activity in the lives of students and this belief pins
          its strategic development. The overall strategic objective of increasing participation both at a
          recreational and elite level can be best
          achieved by ensuring that there are accessible pathways and excellent structures in place to achieve
          this. It is also imperative that GHRSCF identifies and tackles key barriers to student
          participation.
        </p>
        <p>
          Working in partnership with local and national bodies provides valuable aspects, increasing
          opportunities, improving use of valuable resources, and delivering improved return on investments.
          GHRSCF aims to improve, develop and promote
          elite National and International sport through the channels of consistent good practice and
          successes at elite athlete level. (Supports our own group institutions and Society) In the
          implementation of this plan GHRSCF will continue
          to engage with these strategic partners to share best practise models for development of sport and
          recreation.
        </p>
      </div>
    </div>
  </div>
</section>
<section class="section-md circle-gradient-left ">
  <div class="container">
    <div class="row g-5 row-cols-1 row-cols-lg-2">
      <div class="col-lg-3">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="pills-chess-tournament-tab" data-bs-toggle="pill"
              data-bs-target="#pills-chess-tournament" type="button" role="tab" aria-controls="pills-chess-tournament"
              aria-selected="true">Chess Tournament </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-badminton-tab" data-bs-toggle="pill" data-bs-target="#pills-badminton"
              type="button" role="tab" aria-controls="pills-badminton" aria-selected="false">Badminton Tournament
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-fide-tab" data-bs-toggle="pill" data-bs-target="#pills-fide"
              type="button" role="tab" aria-controls="pills-fide" aria-selected="false">Fide Chess </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-neev-tab" data-bs-toggle="pill" data-bs-target="#pills-neev"
              type="button" role="tab" aria-controls="pills-neev" aria-selected="false">Employee Sports & Cultural
              Meet</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-nfb-tab" data-bs-toggle="pill" data-bs-target="#pills-nfb" type="button"
              role="tab" aria-controls="pills-nfb" aria-selected="false">The National Federation Blind</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-rpl-tab" data-bs-toggle="pill" data-bs-target="#pills-rpl" type="button"
              role="tab" aria-controls="pills-rpl" aria-selected="false">Raisoni Premier League</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-sjan-raa-tab" data-bs-toggle="pill" data-bs-target="#pills-sjan-raa"
              type="button" role="tab" aria-controls="pills-sjan-raa" aria-selected="false">SJAN & Raisoni Achievers
              Award</button>
          </li>
        </ul>
      </div>
      <div class="col-lg-9">
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-chess-tournament" role="tabpanel"
            aria-labelledby="pills-chess-tournament-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-chess')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2026', $event, 'inner-tab-events-chess')">2026</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2025', $event, 'inner-tab-events-chess')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-chess')">2024</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-chess">
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nandurbar-chess-tournament-3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 12 July 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G. H. Raisoni Memorial Open Chess Tournament 2026 Successfully
                        Concludes in Nandurbar</h3>
                      <p class="card-text mb-3">The G. H. Raisoni Memorial Open Chess Tournament 2026 was
                        successfully organized on 12th July 2026 at Panchayat Samiti Sabhagruh, Nandurbar,.</p>
                      <div class="d-flex justify-content-between">
                        <a routerLink="/nandurbar-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/gondia-chess-tournament.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 21 June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026</h3>
                      <p class="card-text mb-3">The 2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026 was
                        successfully organized on 21st June 2026 at Vivek Mandir School, Gondia, by the Gondia
                        District Chess Association in association with the G.H. Raisoni Sports & Cultural
                        Foundation, Nagpur, witnessing participation from 198 players including 52 FIDE-rated
                        players.</p>
                      <div class="d-flex justify-content-between">
                        <a routerLink="/memorial-chess-tournament-gondia" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ms-under-11-open-girls-selection-fide-rated-chess-champ-26.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 10-12 July 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G. H. Raisoni Memorial & H2E Power Systems Maharashtra State
                        Under-11 Open and Girls Selection FIDE Rated Chess Championships</h3>
                      <p class="card-text  mb-3">The G.H. Raisoni Memorial & h2e Power Systems Maharashtra State
                        Under-11 Open & Girls Selection FIDE Rated Chess Championship 2026 was successfully held from
                        10–12 July 2026 at Janata Mahavidyalaya, Chandrapur.Organized by the Creative Chess Association,
                        Chandrapur, the championship attracted 144 players from across Maharashtra.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/chess-tournament-chandrapur" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-bhandara.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 21 June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G.H. Raisoni Memorial Gwalior One Day Open Rapid Chess Tournament
                      </h3>
                      <p class="card-text  mb-3"> The G.H. Raisoni Memorial Gwalior One Day Open Rapid Chess
                        Tournament 2026 was successfully conducted at Mahaveer Bhavan, Nai Sadak, Gwalior, Madhya
                        Pradesh, with 218 players participating from six districts of Madhya Pradesh.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/gwalior-one-day-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/pune-chesss-tour.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 18th & 20th June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G H Raisoni Pune District Selection Chess Championship 2026</h3>
                      <p class="card-text  mb-3"> The G H Raisoni Pune District Selection Chess Championship 2026 was
                        successfully held at Ashwamedh Hall, Karve Road, Pune, serving as the official selection
                        event for the Maharashtra State Chess Championships 2026, bringing together 167 players across
                        the Open, Under-17 Open, and Under-17 Girls categories.
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/pune-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/events/pune-international-fide.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>5 July 2026</span>
                      </div>
                      <h3 class="card-title mb-1">4th G H Raisoni Memorial Pune International FIDE Rapid Rating Chess
                        Tournament 2026</h3>
                      <p>The 4th G H Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2026 was
                        successfully held on 5th July 2026 at G H Raisoni College of Engineering &amp; Management,
                        Wagholi,
                        Pune.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/international-fide-rapid-rating-chess-tournament-pune" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/19th-gh-raisoni-memorial-chess-festival-nagpur-26-backdrop.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 7-13 June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G H Raisoni Memorial Nagpur Chess Festival - 2026</h3>
                      <p> The event brought together chess enthusiasts and players from across the country and abroad,
                        providing a competitive platform to showcase talent, promote sportsmanship, and strengthen the
                        spirit of chess within the community.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/ghraisoni-chess-festival" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/katni-intern-fide-rapid-rating-chess-tour.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 31st May 2026</span>
                      </div>
                      <h3 class="card-title mb-1">1st G H Raisoni Memorial Katni International FIDE Rapid Rating Chess
                        Tournament 2026</h3>
                      <p class="card-text  mb-3">The 1st G H Raisoni Memorial Katni International FIDE Rapid Rating
                        Chess Tournament 2026, organized by Katni District Chess Association, G H Raisoni Sports and
                        Cultural Foundation & Kalpana Prakash Welfare Foundation.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/katni-fide-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/india-open-fide-rapid-chess-tour-26-ambikapur.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 30-31 May 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G H Raisoni Memorial All India Fide Rated Rapid Chess Tournament
                        Ambikapur</h3>
                      <p class="card-text  mb-3">The event witnessed enthusiastic participation with 190 registered
                        players
                        representing 5 different State of India.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/ambikapur-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/one-day-rapid-chess-tour-26-surajpur.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 24 May 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G H Raisoni Memorial One Day Rapid Chess Tournament Surajpur</h3>
                      <p class="card-text  mb-3"> The 1st G H Raisoni Memorial One Day Rapid Chess Tournament Surajpur
                        2026, organized by Kalpana Prakash Welfare Foundation in association with G. H.
                        Raisoni University, was a grand success.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/surajpur-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/durg-div-one-day-rapid-rating-chess-tour-26-durg.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 23rd May 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G.H.Raisoni Memorial Durg Divisional One Day Rapid Chess Tournament
                        2026, Durg </h3>
                      <p class="card-text  mb-3"> The G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026, Durg
                        was successfully conducted on
                        23rd May 2026 at the elegant Shri Jalaram Sanskritik Bhawan, Civil Lines, Durg.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/durg-divisional-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sambhajinagar-chess.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> May 3, 2026 </span>
                      </div>
                      <h3 class="card-title mb-1"> G.H. Raisoni Memorial District Selection Chess Tournament 2026, Chh.
                        Sambhajinagar </h3>
                      <p class="card-text  mb-3"> The G.H. Raisoni Memorial Chh. Sambhajinagar District Selection Chess
                        Tournament 2026.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/sambhajinagar-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/durg-divisional-chess.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> May 5, 2026 </span>
                      </div>
                      <h3 class="card-title mb-1"> G H Raisoni khairagarh One Day Rapid Chess Tournament </h3>
                      <p class="card-text  mb-3"> The G.H. Raisoni Memorial Durg Divisional Chess Tournament 2026,
                        Khairagarh was successfully conducted on May 5, 2026.</p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/khairagarh-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-bhandara.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 19 April 2026</span>
                      </div>
                      <h3 class="card-title mb-1"> Bhandara District 1st G. H. Raisoni Memorial Rapid Chess Tournament
                        2026 </h3>
                      <p class="card-text  mb-3"> Bhandara District 1st G. H. Raisoni Memorial Rapid Chess Tournament
                        2026
                        was successfully
                        organized on 19 April 2026. </p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/bhandara-rapid-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratlam-chess-tournament.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 4th April 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G.H. Raisoni Memorial Ratlam One Day Open Rapid Chess Tournament 2026
                      </h3>
                      <p class="card-text  mb-3"> The G. H. Raisoni Memorial Ratlam One Day Rapid Chess Championship
                        2026
                        was successfully
                        organized on 4th April 2026. </p>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/ratlam-open-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 1st March 2026</span>
                      </div>
                      <h3 class="card-title">Nagpur District Rapid & Blitz Chess Championship 2026
                      </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-district-rapid-blitz-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/26th-nationals-chess-championship/deaf-chess-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 16th to 20th February 2026</span>
                      </div>
                      <h3 class="card-title"> 26th National Chess Championship of the Deaf – 2026 </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/twenty-eigth-nationals-chess-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-open-tournament/chess-open-tournament-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>15 Feb 2026</span>
                      </div>
                      <h3 class="card-title"> NAGPUR District Tournament Open and Women_s Selection Chess Championship
                      </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/chess-open-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>8 Feb 2026</span>
                      </div>
                      <h3 class="card-title"> 1st G H Raisoni Memorial Jalna International Fide Rapid Rating Chess
                        Tournament </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/jalna-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 8th February 2026</span>
                      </div>
                      <h3 class="card-title">G.H. Raisoni Memorial Singruali One Day Open Rapid Chess Tournament 2026
                      </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/singrauli-district-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-1.png"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 11th January 2026</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under 07-17 Boys & Girls Selection Chess Championship 2026
                      </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-district-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 11th January 2026</span>
                      </div>
                      <h3 class="card-title"> G H Raisoni Memorial Jalna Open Chess Tournament</h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/jalna-open-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/inter-nag-chess-fes/inter-nag-chess-fes.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 8th to 15th June 2025 </span>
                      </div>
                      <h3 class="card-title">18th GH Raisoni Memorial International Nagpur Chess Festival</h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-chess-festival" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-rapid-chess-tournament/sambhaji-ngr-chess.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 4th May 2025 </span>
                      </div>
                      <h3 class="card-title">G. H. Raisoni Memorial Jalna Rapid Chess Tournament 2025 – Successfully
                        Organized by Glorious Chess Academy </h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/jalna-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rai-dist-leve-one-day/rai-dist-leve-one-day-2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> November 2025 </span>
                      </div>
                      <h3 class="card-title">G.H. Raisoni Memorial Raigad District-Level One-Day Chess Tournament
                        Concludes Successfully</h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/raigad-district-level-one-day" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rapid-chess-tournament+/rapid-chess-tournament-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 2nd November 2025 </span>
                      </div>
                      <h3 class="card-title"> G.H. Raisoni Memorial Bastar Division Rapid Chess Tournament Concludes
                        Successfully in Jagdalpur</h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/rapid-chess-tournament-concludes" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/suguja-division-rapid-chess/suguja-division-rapid-chess.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 27th October 2025 </span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Sarguja Division one day chess Tournament 2025</h3>

                      <div class="d-flex justify-content-between ">
                        <a routerLink="/sarguja-division-one-day-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/potharia-rapid-chess-tournament25/potharia-rapid-chess-tournament-gallery25.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 10th October 2025 </span>
                      </div>
                      <h3 class="card-title">Pithora One-Day Rapid Chess Tournament 2025 </h3>
                      <!-- <p class="card-text mt-2">
                        The Division Level Chess Meet 2025 – Nagpur was inaugurated on 15th August 2025 at
                        G.H. Raisoni Institute, Wadi.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/pithora-one-day-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1 h-100">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/division-level-chess-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 29th September 2025 </span>
                      </div>
                      <h3 class="card-title">Division Level Chess Meet 2025 – Nagpur</h3>
                      <!-- <p class="card-text mt-2">
                        The Division Level Chess Meet 2025 – Nagpur was inaugurated on 15th August 2025 at
                        G.H. Raisoni Institute, Wadi.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/division-level-chess-meet" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/thane-fide-rapid-chess/thane-fide-rapid-chess.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th September 2025 </span>
                      </div>
                      <h3 class="card-title">1st G H Raisoni Memorial Thane FIDE Rating Chess Tournament </h3>
                      <!-- <p class="card-text mt-2">
                        The Division Level Chess Meet 2025 – Nagpur was inaugurated on 15th August 2025 at
                        G.H. Raisoni Institute, Wadi.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/thane-fide-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngp-1700-fide-rating-chess-tournament.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 15th – 17th August 2025,</span>
                      </div>
                      <h3 class="card-title">5th Nagpur Below 1700 FIDE Rating Chess Tournament</h3>
                      <!-- <p class="card-text mt-2">
                        The 5th Nagpur Below 1700 FIDE Rating Chess Tournament was inaugurated on 15th August 2025 at
                        G.H. Raisoni Institute, Wadi.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-below-seventeen-hundred-fide-rating-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 20th July 2025,</span>
                      </div>
                      <h3 class="card-title"> Chess Association Nagpur Celebrates 101st International Chess
                        Day</h3>
                      <!-- <p class="card-text mt-2">
                        Chess Association Nagpur celebrated the 101st International Chess Day with great enthusiasm on
                        20th July 2025.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/chess-association-ngp-celebrates-international-chess-day" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-prise-distribution-25/chess-prise-distribution-25-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 13th - 16th, June 2025,</span>
                      </div>
                      <h3 class="card-title"> Chess Competition Prize Distrubution 2025</h3>
                      <!-- <p class="card-text mt-2">
                        Raisoni Foundation proudly felicitated the winners of the Chess Competition, recognising their
                        discipline, analytical skill, and competitive spirit.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/chess-competition-prize-distrubution" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-4.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 12th, May 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Nanded District Chess Selection Tournament
                        2025</h3>
                      <!-- <p class="card-text">
                        We are proud to share the highlights of the G H Raisoni Memorial Nanded District Chess
                        Selection Tournament 2025, successfully conducted on May 12th in Nanded.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nanded-district-chess-selection-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col " data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 17th - 18th May 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Ratnagiri District Selection Chess
                        Tournament 2025 – Concludes Successfully!</h3>
                      <!-- <p class="card-text">
                        The G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025 (Open & Women
                        categories)
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/memorial-chess-tournament-ratnagiri" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-2.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 25th, April 2025,</span>
                      </div>
                      <h3 class="card-title">Chess Tournament 2025</h3>
                      <!-- <p class="card-text">
                        G H Raisoni Memorial Nandurbar selection chess tournament was held in the gymkhana hall of
                        G.T. Patil College in Association with Raisoni Foundation- Sports and Culture and Kalpana
                        Prakash Welfare Foundation A total of 82 players participated in the competition.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-tournament-twenty-five" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th, April 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-11 & Under-15 Selection Chess Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        Nagpur District Under-11 & Under-15 Selection Chess Championships for Open and Girls
                        categories were successfully organized at Vivekanand Hall, Shraddha House, Kingsway,
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-eleven-fifteen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 30th, March 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-9 & Under-19 Selection Chess Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        The Nagpur District Under-9 & Under-19 Selection Chess Championship for Open and Girls
                        categories concluded successfully at Vivekanand Hall, Shraddha House, Kingsway, near
                        Kasturchand Park, Nagpur.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-nine-nineteen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 23rd, March 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-07 and Under-17 Chess Championship 2025
                      </h3>
                      <!-- <p class="card-text">
                        Organized by Chess Association Nagpur in collaboration with G H Raisoni Sports and Cultural
                        Foundation, MKH Sancheti Group, and Kalpana Prakash Welfare Foundation, the championship was
                        held at Vivekanand Hall, Shraddha House, Nagpur.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-seven-seventeen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-6.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 23, February 2025,</span>
                      </div>
                      <h3 class="card-title">G H Memorial Bhandara One-Day Rapid Chess Tournament</h3>
                      <!-- <p class="card-text">
                        The G H Memorial Bhandara One-Day Rapid Chess Tournament was successfully held on February
                        23, 2025, at Badge Celebration Hall, Lakhani, attracting players from various districts,
                        including Nagpur, Bhandara, Chandrapur, Gadchiroli, Gondia, and Rajnandgaon.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/bhandara-one-day-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 19, January 2025</span>
                      </div>
                      <h3 class="card-title">
                        Nagpur District Under 13 Open and Girls Selection Chess Championship

                        2025
                      </h3>
                      <!-- <p class="card-text">
                        The Nagpur District Under 13 Open and Girls Selection Chess Championship 2025, organized
                        by Chess Association Nagpur in association with G H Raisoni Sports and Cultural Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/open-and-girls-selection-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date  mb-2">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 12, January 2025</span>
                      </div>
                      <h3 class="card-title mb-2">Nagpur District Open & Women's Chess Championship 2025</h3>
                      <!-- <p class="card-text">
                        Nagpur, January 12, 2025 – Nagpur District Open and Women's Chess Championship 2025,
                        organized by Chess Association Nagpur in association with G H Raisoni Sports and Cultural
                        Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/womens-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-1.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 10
                          <sup>th</sup> November 2024
                        </span>
                      </div>
                      <h3 class="card-title"> Pune GH Raisoni Foundation & PlayerOrbit Checkmate Challenge</h3>
                      <!-- <p class="card-text">The GH Raisoni Foundation and PlayerOrbit Pune Checkmate Challenge 2024 was
                        held in Pune on November 10, 2024, at Amanora Mall, Pune.</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/pune-checkmate-challenge" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> September 2024</span>
                      </div>
                      <h3 class="card-title"> Nagpur District Blitz Chess Championship</h3>
                      <!-- <p class="card-text">
                        The championship was organised by Chess Association Nagpur in association
                        with Kalpana Prakash Welfare Foundation and G HRaisoni Sports and Cultural Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/blitz-chess-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rgi-monsoon-chess.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> August 2024</span>
                      </div>
                      <h3 class="card-title"> Raisoni Monsoon Chess Festival</h3>
                      <!-- <p class="card-text">The 4
                        <sup>th</sup>
                        Nagpur below 1800 open fide rating chess tournament
                        &amp; 2
                        <sup>nd</sup>
                        Nagpur one day International fide rapid rating chess tournament.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/rgi-monsoon-chess.pdf"
                          target="_blank" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial-international.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date mb-3">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> June 2024</span>
                      </div>
                      <h3 class="card-title"> 17
                        <sup>th</sup>
                        G H Raisoni Memorial international Rating Chess
                        Festival
                      </h3>
                      <!-- <p class="card-text">The 17
                        <sup>th</sup>
                        edition of the G H Raisoni Memorial International
                        Rating Chess
                        Festival
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/memorial-international" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> March 2024</span>
                      </div>
                      <h3 class="card-title"> Nagpur District Under-7 Open and Girls Chess Championship</h3>
                      <!-- <p class="card-text">
                        organized by Chess
                        Association Nagpur in association with GHRSCF
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/nagpur-open-girls-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-badminton" role="tabpanel" aria-labelledby="pills-badminton-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-badminton')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2026', $event, 'inner-tab-events-badminton')">2026</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2025', $event, 'inner-tab-events-badminton')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-badminton')">2024</a>
                  </nav>
                </div>
              </div>

              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-21 justify-content-center g-3"
                id="inner-tab-events-badminton">
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yonex-ngp-badminton-26-1.webp"
                        class="card-img-top rounded"
                        alt="YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection Badminton Tournament 2026 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>19th - 21st June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">YONEX-SUNRISE G.H. Raisoni Memorial Nagpur District Selection
                        Badminton Tournament 2026
                      </h3>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/yonex-nagpur-district" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/yavatmal-district/yavatmal-district-1.webp"
                        class="card-img-top rounded"
                        alt="GH Raisoni Memorial Yavatmal District Badminton Championship 2026 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>19th - 21st June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">GH Raisoni Memorial Yavatmal District Badminton Championship 2026
                      </h3>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/yavatmal-district-badminton" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/nagpur-district/ngp-badminton-26-1.webp"
                        class="card-img-top rounded"
                        alt="YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior Selection Badminton Tournament 2026 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>5th - 9th August 2026</span>
                      </div>
                      <h3 class="card-title mb-1">YONEX-SUNRISE G.H. Raisoni Memorial 2nd Maharashtra State Sub-Junior
                        (U-9, U-11 & U-13) Selection Badminton Tournament 2026 </h3>
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/maharashtra-state-sub-junior" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-8.webp"
                        class="card-img-top rounded" alt="Amravati District Badminton Championship 2026 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <!-- <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>6th &amp; 7th June 2026</span>
                      </div> -->
                      <h3 class="card-title mb-1">G. H. Raisoni Memorial Madhya Pradesh State Junior (U-19) Ranking
                        Badminton Tournament 2026 held at Khargone
                      </h3>
                      <!-- <p class="card-text mb-3">203 players participated across Under-13 to Senior categories at District Sports Complex, Amravati.</p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/khargone-badminton" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-1.webp"
                        class="card-img-top rounded" alt="Amravati District Badminton Championship 2026 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>6th &amp; 7th June 2026</span>
                      </div>
                      <h3 class="card-title mb-1">G. H. Raisoni Memorial Amravati District Badminton Championship 2026
                      </h3>
                      <!-- <p class="card-text mb-3">203 players participated across Under-13 to Senior categories at District Sports Complex, Amravati.</p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/amravati-district-badminton" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amateur-2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>7th May – 10th May 2026</span>
                      </div>
                      <h3 class="card-title">Amature Badminton tournament</h3>
                      <!-- <p class="card-text mt-2"> Raisoni Foundation Presents Yones Sunrise, Badminton
                        Tournament -2025

                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-district-amateur-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/marathwada-open/marathwada-open-1.webp"
                        class="card-img-top rounded" alt="Badminton Championship 2025 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <!-- <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 29th August 2025 </span>
                      </div> -->
                      <h3 class="card-title"> YONEX-SUNRISE G.H. Raisoni Memorial MARATHWADA OPEN Badminton Tournament
                        2025 </h3>
                      <div class="d-flex justify-content-between">
                        <a class="cmn-button"
                          href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/all-series-draws.pdf"
                          target="_blank">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/malka-inter-school-batminton.webp"
                        class="card-img-top rounded" alt="Badminton Championship 2025 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 29th August 2025 </span>
                      </div>
                      <h3 class="card-title">G H Raisoni Foundation Malka Inter-School Badminton Monsoon season 2025
                      </h3>
                      <div class="d-flex justify-content-between">
                        <a class="cmn-button"
                          href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/all-series-draws.pdf"
                          target="_blank">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/men-womens-badminton.webp"
                        class="card-img-top rounded" alt="Badminton Championship 2025 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 29th August 2025 </span>
                      </div>
                      <h3 class="card-title">G H Raisoni Foundation State Men & Women Badminton Championship 2025
                      </h3>
                      <div class="d-flex justify-content-between ">
                        <a class="cmn-button"
                          href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/all-series-draws.pdf"
                          target="_blank">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanded-district-badminton/nanded-dis-bad-1.webp"
                        class="card-img-top rounded" alt="Badminton Championship 2025 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 9th & 10th August 2025 </span>
                      </div>
                      <h3 class="card-title">21st Nanded District Badminton Championship 2025</h3>
                      <!-- <p class="card-text">
                        The 21st Nanded District Badminton Championship 2025 – Yonex Sunrise G H Raisoni Memorial
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nanded-district-badminton-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghraisoni-memorial-amravati-batminton-champ-25/ghraisoni-memorial-amravati-batminton-champ-25.webp"
                        class="card-img-top rounded" alt="Badminton Championship 2025 | GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>5th to 6th July 2025</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Amravati District Badminton Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        G H Raisoni Memorial Amravati District Badminton Championship 2025
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/ghraisoni-memorial-amravati-district-badminton-championship-twentyfive"
                          class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/telangana-state-senior1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>25th June to 28th June 2025</span>
                      </div>
                      <h3 class="card-title">Telangana State Senior
                        Badminton Championship 2025 </h3>
                      <!-- <p class="card-text"> G H. Raisoni Memorial Yonex-Sunrise 11 th Telangana State Senior
                        Badminton Championship 2025 (Men &amp; Women)

                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/telangana-state-senior-bad-cham" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/palghar-batminton-25/palghar-batminton-25-8.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 6th - 8th, June 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Palghar District Badminton Championship
                        2025</h3>
                      <!-- <p class="card-text mt-2">
                        The championship witnessed overwhelming participation from budding and seasoned players across
                        multiple age groups and categories.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/palghar-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>1st – 8th June 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Pune District Badminton Championship 2025
                      </h3>
                      <!-- <p class="card-text mt-2">
                        "Raisoni Foundation Presents Yonex-Sunrise G H Raisoni Memorial Pune District Badminton
                        Championship 2025
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/pune-dist-badminton-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 1st – 4th May 2025</span>
                      </div>
                      <h3 class="card-title">Nagpur District 1st Selection Badminton Tournament 2025</h3>
                      <!-- <p class="card-text">
                        The Nagpur District 1st Selection Badminton Tournament 2025 concluded successfully on 4th May
                        2025,
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-district-first-selection-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/level-women-badminton1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>7th to 9th March 2025</span>
                      </div>
                      <h3 class="card-title"> Yonex-Sunrise Sadabai Raisoni Memorial Maharashtra State
                        Women’s Badminton Tournament 2025 </h3>
                      <!-- <p class="card-text mt-2">
                        The Raisoni Foundation Presents Yonex-Sunrise Smt. Sadabai Raisoni Memorial Maharashtra State
                        Women’s Badminton Tournament
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/mh-womens-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/batminton-tournament-buldhana-25.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 20 April 2025</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Buldhana District Badminton Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        We are delighted to share the successful completion of the G H Raisoni Memorial Buldhana
                        District Badminton Championship 2025,
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/buldhana-district-badminton-championship-twenty-five" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sada-rai-wom-batmtn-2024-4.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>8th to 10th March 2024</span>
                      </div>
                      <h3 class="card-title">Sadabai Raisoni Memorial Maharashtra State level Women's
                        Badminton Tournament 2024 </h3>
                      <!-- <p class="card-text">
                        Sadabai Raisoni Memorial Maharashtra State level Women's Badminton Tournament 2024
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/sadabai-raisoni-womens-batminton" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-2.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> September 2024</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Vidarbha Level Badminton Tournament
                      </h3>
                      <!-- <p class="card-text">
                        Hats off to all the amazing players at the Yonex-Sunrise G H Raisoni Memorial Vidarbha Level
                        Badminton Tournament!
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/raisoni-memorial-vidarbha-level-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-pune-1.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> June 2024</span>
                      </div>
                      <h3 class="card-title"> Badminton Competition</h3>
                      <!-- <p class="card-text">
                        "Serving up excellence, one shuttle at a time.
                        Thrilled to inaugurate the 2024 Badminton Competition at GHRCEM Pune!
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/badminton-competition" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-fide" role="tabpanel" aria-labelledby="pills-fide-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-fide')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2025', $event, 'inner-tab-events-fide')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-fide')">2024</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-fide">

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-pune-fide-rapit-25/chess-pune-fide-rapit-25-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 13th july 2025</span>
                      </div>
                      <h3 class="card-title">3rd G H. Raisoni Memorial Pune International FIDE Rapid Rating
                        Chess Tournament 2025
                      </h3>
                      <!-- <p class="card-text mt-2">
                        The 3rd G H. Raisoni Memorial Pune International FIDE Rapid Rating Chess Tournament 2025
                        concluded successfully with a vibrant and well-attended prize distribution ceremony.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/ghr-memorial-pune-fide-rapid-rating-chess-twentyfive" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 2nd, March 2025,</span>
                      </div>
                      <h3 class="card-title">Chhatrapati Sambhaji Nagar FIDE Rapid Rating Chess Tournament
                      </h3>
                      <!-- <p class="card-text">
                        We are thrilled to announce the G H Raisoni Memorial Chhatrapati Sambhaji Nagar FIDE Rapid
                        Rating Chess Tournament, scheduled for 2nd March 2025. The tournament will take place at the
                        Himalaya Public School, Beed Bypass Road, Arjun Nagar, Chhatrapati Sambhaji Nagar,
                        Maharashtra.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-rapid-rating-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-4.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>9, February 2025,</span>
                      </div>
                      <h3 class="card-title">2nd G H Raisoni Memorial Amravati International FIDE Rapid Rating
                        Chess Tournament</h3>
                      <!-- <p class="card-text">
                        Amravati, February 9, 2025 – The 2nd G H Raisoni Memorial Amravati FIDE Rapid Rating Chess
                        Tournament concluded successfully with IM Kushagra Mohan from Telangana emerging as the
                        winner.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/international-fide-rapid-rating-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-6.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>
                          November 10,
                          2018 - 2024
                        </span>
                      </div>
                      <h3 class="card-title">Fide Chess Competition</h3>
                      <!-- <p class="card-text">
                        It is a long established fact that a reader will be distracted by the
                        readable content of a page layout.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-chesscompetition" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-neev" role="tabpanel" aria-labelledby="pills-neev-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-neev')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2026', $event, 'inner-tab-events-neev')">2026</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2025', $event, 'inner-tab-events-neev')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-neev')">2024</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-neev">

                <div class="col" data-year="2026">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-35.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 15<sup>th</sup>, 16<sup>th</sup> and 17<sup>th</sup> January 2026</span>
                      </div>
                      <h3 class="card-title"> 22<sup>th</sup> Employee Sports & Cultural Meet</h3>
                      <div class="d-flex justify-content-between">
                        <a routerLink="/neev-twenty-six" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 16<sup>th</sup>, 17<sup>th</sup> and 18<sup>th</sup> January 2025</span>
                      </div>
                      <h3 class="card-title">Employee Sports & Cultural Meet</h3>
                      <!-- <p class="card-text">
                        G H Raisoni Sports and Cultural Foundation organizing Raisoni Group's Employee.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/neev-twenty-five" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-1.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> January 2024</span>
                      </div>
                      <h3 class="card-title">Employee Sports & Cultural Meet</h3>
                      <!-- <p class="card-text">
                        G H Raisoni Sports and Cultural Foundation organizing Raisoni Groups Employee.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/neev-employee-sports-meet" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-nfb" role="tabpanel" aria-labelledby="pills-nfb-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-nfb')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-nfb')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2023', $event, 'inner-tab-events-nfb')">2023</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2019', $event, 'inner-tab-events-nfb')">2019</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-nfb">

                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bling-fedration.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 28
                          <sup>th</sup> December 2025
                        </span>
                      </div>
                      <h3 class="card-title">The National Federation of Blind Celebration</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/the-national-federation-of-blind.pdf"
                          target="_blank" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2023">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bling-fedration.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 15
                          <sup>th</sup> October 2023
                        </span>
                      </div>
                      <h3 class="card-title">The National Federation of Blind Celebration</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/national-federation-of-blind" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2019">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-7.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> October 15, 2019</span>
                      </div>
                      <h3 class="card-title">The National Federation of Blind</h3>
                      <!-- <p class="card-text">
                        It is a Non Political, Membership based, Self-help social and democratic
                        Organization.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/national-federation" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-rpl" role="tabpanel" aria-labelledby="pills-rpl-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-rpl')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2021', $event, 'inner-tab-events-rpl')">2021</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-rpl">

                <div class="col" data-year="2021">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>2021</span>
                      </div>
                      <h3 class="card-title">Raisoni Premier League</h3>
                      <!-- <p class="card-text">
                        We at the Raisoni Group of Institutions have in a little time frame reached
                        milestones of success.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/raisoni-premier-league" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-sjan-raa" role="tabpanel" aria-labelledby="pills-sjan-raa-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                      (click)="filterInnerTabs('all', $event, 'inner-tab-events-sjan')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                      (click)="filterInnerTabs('2024', $event, 'inner-tab-events-sjan')">2024</a>
                  </nav>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3"
                id="inner-tab-events-sjan">

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-5.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>January 6, 2024</span>
                      </div>
                      <h3 class="card-title">SJAN &amp; Raisoni Achievers Award</h3>
                      <!-- <p class="card-text">
                        SJAN, Raisoni Group of Institutions started this Raosni Achiever's Award in
                        Collaboration.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/sjan-award" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="pills-nothing" role="tabpanel" aria-labelledby="pills-nothing-tab">
            <div class="university campus-buzz">
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <div class="tab-list">
                    <div class="filter mt-0 mb-lg-5 mb-0">
                      <nav class="nav nav-pills d-flex justify-content-center">
                        <a class="nav-link active" data-bs-filter=".fide-all">All</a>
                        <a href="javascript:void(0)" class="nav-link cmn-button" data-bs-filter=".fide-2025">2025</a>
                        <a href="javascript:void(0)" class=" nav-link cmn-button" data-bs-filter=".fide-2024">2024</a>
                        <a href="javascript:void(0)" class=" nav-link cmn-button" data-bs-filter=".fide-2023">2023</a>
                        <a href="javascript:void(0)" class=" nav-link cmn-button" data-bs-filter=".fide-2022">2022</a>
                        <a href="javascript:void(0)" class=" nav-link cmn-button" data-bs-filter=".fide-2021">2021</a>
                        <!-- <a href="javascript:void(0)" "  class=" nav-link cmn-button" data-bs-filter=".fide-2020" >2020</a>-->
                        <a href="javascript:void(0)" class=" nav-link cmn-button" data-bs-filter=".fide-2019">2019</a>

                      </nav>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-2 row-cols-md-2 row-cols-2 justify-content-center g-3" id="inner-tab-events">
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nanaded-tour-25-4.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 12th, May 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Nanded District Chess Selection Tournament
                        2025</h3>
                      <!-- <p class="card-text">
                        We are proud to share the highlights of the G H Raisoni Memorial Nanded District Chess
                        Selection Tournament 2025, successfully conducted on May 12th in Nanded.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nanded-district-chess-selection-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ngpr-dist-1st-selection-badminton3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th, April 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District 1st Selection Badminton Tournament 2025</h3>
                      <!-- <p class="card-text">
                        The Nagpur District 1st Selection Badminton Tournament 2025 concluded successfully on 4th May
                        2025, after four days of intense competition and spectacular display of talent. Hosted at the
                        state-of-the-art Subhedar Badminton Hall within the RTMNU Campus,
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/nagpur-district-first-selection-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ratnagiri-chess-tournament-25.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th, April 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Ratnagiri District Selection Chess
                        Tournament 2025 – Concludes Successfully!</h3>
                      <!-- <p class="card-text">
                        The G H Raisoni Memorial Ratnagiri District Selection Chess Tournament 2025 (Open & Women
                        categories) concluded today with a vibrant display of talent, strategy, and sportsmanship.
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/memorial-chess-tournament-ratnagiri" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-2.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th, April 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Vidarbha Level Badminton Tournament
                      </h3>
                      <!-- <p class="card-text">
                        Hats off to all the amazing players at the Yonex-Sunrise G H Raisoni Memorial Vidarbha Level
                        Badminton Tournament! Your passion is unmatched. Congratulations to all!
                      </p> -->
                      <div class="d-flex justify-content-between ">
                        <a routerLink="/raisoni-memorial-vidarbha-level-badminton-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-tour-25-2.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 25th, April 2025,</span>
                      </div>
                      <h3 class="card-title">Chess Tournament 2025</h3>
                      <!-- <p class="card-text">
                        G HRaisoni Memorial Nandurbar selection chess tournament was held in the gymkhana hall of
                        G T. Patil College in Association with Raisoni Foundation- Sports and Culture and Kalpana
                        Prakash Welfare Foundation A total of 82 players participated in the competition. Out of
                        these, 10 players were selected from the open category.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-tournament-twenty-five" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/batminton-tournament-buldhana-25.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 25th, April 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Buldhana District Badminton Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        We are delighted to share the successful completion of the G H Raisoni Memorial Buldhana
                        District Badminton Championship 2025, held on 20th and 21st April 2025 at the Indoor Sports
                        Facility Center, J.K.V.M, Malkapur, District Buldhana.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/buldhana-district-badminton-championship-twenty-five" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/under19-chess-champianship3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 14th, April 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-11 & Under-15 Selection Chess Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        Nagpur District Under-11 & Under-15 Selection Chess Championships for Open and Girls
                        categories were successfully organized at Vivekanand Hall, Shraddha House, Kingsway, near
                        Kasturchand Park, Nagpur. The prestigious event was conducted by Chess Association Nagpur,..
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-eleven-fifteen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ghrscf-under-nine-nineteen2.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 30th, March 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-9 & Under-19 Selection Chess Championship
                        2025</h3>
                      <!-- <p class="card-text">
                        The Nagpur District Under-9 & Under-19 Selection Chess Championship for Open and Girls
                        categories concluded successfully at Vivekanand Hall, Shraddha House, Kingsway, near
                        Kasturchand Park, Nagpur. The event was organized by Chess Association Nagpur in association
                        with G H Raisoni Sports..
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-nine-nineteen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 23rd, March 2025,</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under-07 and Under-17 Chess Championship 2025
                      </h3>
                      <!-- <p class="card-text">
                        Organized by Chess Association Nagpur in collaboration with G H Raisoni Sports and Cultural
                        Foundation, MKH Sancheti Group, and Kalpana Prakash Welfare Foundation, the championship was
                        held at Vivekanand Hall, Shraddha House, Kingsway, near Kasturchand Park.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship-under-seven-seventeen" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 2nd, March 2025,</span>
                      </div>
                      <h3 class="card-title">Chhatrapati Sambhaji Nagar FIDE Rapid Rating Chess Tournament
                      </h3>
                      <!-- <p class="card-text">
                        We are thrilled to announce the G H Raisoni Memorial Chhatrapati Sambhaji Nagar FIDE Rapid
                        Rating Chess Tournament, scheduled for 2nd March 2025. The tournament will take place at the
                        Himalaya Public School, Beed Bypass Road, Arjun Nagar, Chhatrapati Sambhaji Nagar,
                        Maharashtra.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-rapid-rating-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-2.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 16, Feb 2025,</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Chess Tournament Gondia</h3>
                      <!-- <p class="card-text">
                        The G H Raisoni Memorial Chess Tournament, Organized by the G H Raisoni Sports & Cultural
                        Foundation & the Kalpana Prakash Welfare Foundation, witnessed an exciting display of chess
                        skills. The tournament took place in Gondia & saw fierce competition from players across
                        Vidarbha, Chhattisgarh, & Madhya Pradesh.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/memorial-chess-tournament-gondia" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-6.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 23, February 2025,</span>
                      </div>
                      <h3 class="card-title">G H Memorial Bhandara One-Day Rapid Chess Tournament</h3>
                      <!-- <p class="card-text">
                        The G H Memorial Bhandara One-Day Rapid Chess Tournament was successfully held on February
                        23, 2025, at Badge Celebration Hall, Lakhani, attracting players from various districts,
                        including Nagpur, Bhandara, Chandrapur, Gadchiroli, Gondia, and Rajnandgaon.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/bhandara-one-day-rapid-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-4.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>9, February 2025,</span>
                      </div>
                      <h3 class="card-title">2nd G H Raisoni Memorial Amravati International FIDE Rapid Rating
                        Chess Tournament</h3>
                      <!-- <p class="card-text">
                        Amravati, February 9, 2025 – The 2nd G H Raisoni Memorial Amravati FIDE Rapid Rating Chess
                        Tournament concluded successfully with IM Kushagra Mohan from Telangana emerging as the
                        winner.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/international-fide-rapid-rating-chess-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 19, January 2025</span>
                      </div>
                      <h3 class="card-title">
                        Nagpur District Under 13 Open and Girls Selection Chess Championship

                        2025
                      </h3>
                      <!-- <p class="card-text">
                        The Nagpur District Under 13 Open and Girls Selection Chess Championship 2025, organized
                        by Chess Association Nagpur in association with G H Raisoni Sports and Cultural Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/open-and-girls-selection-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2025">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 12, January 2025</span>
                      </div>
                      <h3 class="card-title">Nagpur District Open & Women's Chess Championship 2025</h3>
                      <!-- <p class="card-text">
                        Nagpur, January 12, 2025 – Nagpur District Open and Women's Chess Championship 2025,
                        organized by Chess Association Nagpur in association with G H Raisoni Sports and Cultural
                        Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/womens-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-1.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> September 2024</span>
                      </div>
                      <h3 class="card-title"> Nagpur District Blitz Chess Championship</h3>
                      <!-- <p class="card-text">
                        The championship was organised by Chess Association Nagpur in association
                        with Kalpana Prakash Welfare Foundation and G HRaisoni Sports and Cultural Foundation
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/blitz-chess-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/rgi-monsoon-chess.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> August 2024</span>
                      </div>
                      <h3 class="card-title"> Raisoni Monsoon Chess Festival</h3>
                      <!-- <p class="card-text">The 4
                        <sup>th</sup>
                        Nagpur below 1800 open fide rating chess tournament
                        &amp; 2
                        <sup>nd</sup>
                        Nagpur one day International fide rapid rating chess tournament.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/rgi-monsoon-chess.pdf"
                          target="_blank" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton-pune-1.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> June 2024</span>
                      </div>
                      <h3 class="card-title"> Badminton Competition</h3>
                      <!-- <p class="card-text">
                        "Serving up excellence, one shuttle at a time.
                        Thrilled to inaugurate the 2024 Badminton Competition at GHRCEM Pune!
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/badminton-competition" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial-international.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> June 2024</span>
                      </div>
                      <h3 class="card-title"> 17
                        <sup>th</sup>
                        G H Raisoni Memorial international Rating Chess
                        Festival
                      </h3>
                      <!-- <p class="card-text">The 17
                        <sup>th</sup>
                        edition of the G H Raisoni Memorial International
                        Rating Chess
                        Festival
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/memorial-international" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-open-girls-chess.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> March 2024</span>
                      </div>
                      <h3 class="card-title"> Nagpur District Under-7 Open and Girls Chess Championship</h3>
                      <!-- <p class="card-text">
                        organized by Chess
                        Association Nagpur in association with GHRSCF
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/nagpur-open-girls-chess" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-6.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>
                          November 10,
                          2018 - 2024
                        </span>
                      </div>
                      <h3 class="card-title">Fide Chess Competition</h3>
                      <!-- <p class="card-text">
                        It is a long established fact that a reader will be distracted by the
                        readable content of a page layout.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-chesscompetition" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> February 2024</span>
                      </div>
                      <h3 class="card-title">Women's Chess Championship</h3>
                      <!-- <p class="card-text">Nagpur district open and women's Chess Championship.</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-1.avif"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> January 2024</span>
                      </div>
                      <h3 class="card-title">Employee Sports & Cultural Meet</h3>
                      <!-- <p class="card-text">
                        G H Raisoni Sports and Cultural Foundation organizing Raisoni Groups Employee.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/employee-sport-meet" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col" data-year="2024">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-5.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>January 6, 2024</span>
                      </div>
                      <h3 class="card-title">SJAN &amp; Raisoni Achievers Award</h3>
                      <!-- <p class="card-text">
                        SJAN, Raisoni Group of Institutions started this Raosni Achiever's Award in
                        Collaboration.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/sjan-award" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col  box fide-all fide-2023">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bling-fedration.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 15
                          <sup>th</sup> October
                        </span>
                      </div>
                      <h3 class="card-title">The National Federation of Blind Celebration</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/national-federation-of-blind" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col  box fide-all fide-2023">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> 25
                          <sup>th</sup>
                          June
                          and 2
                          <sup>nd</sup> July 2023
                        </span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Maha Basket 3x3 State Championship Event</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/basketball-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="col  box fide-all fide-2019">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-7.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span> October 15, 2019</span>
                      </div>
                      <h3 class="card-title">The National Federation of Blind</h3>
                      <!-- <p class="card-text">
                        It is a Non Political, Membership based, Self-help social and democratic
                        Organization.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/national-federation" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col  box fide-all fide-2021">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/eve-3.webp"
                        class="card-img-top rounded" alt="GHRSCF">
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                        <span>2021</span>
                      </div>
                      <h3 class="card-title">Raisoni Premier League</h3>
                      <!-- <p class="card-text">
                        We at the Raisoni Group of Institutions have in a little time frame reached
                        milestones of success.
                      </p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/raisoni-premier-league" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 12<sup>th</sup> January 2025</span>
                      </div>
                      <h3 class="card-title">SJAN T20 Cricket Tournament</h3>
                      <!-- <p class="card-text">Defending champions Lokmat will take on Loksatta in the opening encounter of 25th Inter-Press Invitational T20 Cricket🏏</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/sjan-t20-cricket-tournament" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cricket-tournament-8.avif"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 12<sup>th</sup> January 2025</span>
                      </div>
                      <h3 class="card-title">NEEV Employee Sports Meet 2025</h3>
                      <!-- <p class="card-text">Celebrating the excitement and teamwork at the NEEV Employee Sports Meet 2025 Cricket Tournament! 🏏</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/cricket-tournament-2025" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/batmintan.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 28 <sup>th</sup> June to 30 <sup>th</sup> June 2024</span>
                      </div>
                      <h3 class="card-title">G H Raisoni Memorial Gondia District Badminton Championship 2024</h3>

                      <div class="d-flex justify-content-between">
                        <a routerLink="/badminton-championship" class="cmn-button">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/international_chess/chess_tour.avif"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 1<sup>st</sup> October 2023</span>
                      </div>
                      <h3 class="card-title">G HRaisoni Memorial International FIDE Rapid Rating Chess Tournament
                        blooms in Pune</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/pune-international-chess-tournament" class="cmn-button"> Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-1.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 13<sup>th</sup> and 16<sup>th</sup> August 2023</span>
                      </div>
                      <h3 class="card-title">3rd Nagpur Below 1600 Open Fide Rating Chess Tournament and 1st Nagpur
                        One Day Rapid Rating Chess Tournament</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-rating-chess2023" class="cmn-button"> Read More </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-1.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">

                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 25<sup>th</sup> June and 2<sup>nd</sup> July 2023</span>
                      </div>
                      <h3 class="card-title">16th GH Raisoni Memorial International Rating Nagpur Chess Festival
                      </h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/fide-chess2023" class="cmn-button"> Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-event7.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 18<sup>th</sup> June 2023</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under 11 chess tournament</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from  Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/nagpur-district-under-elleven-tournament" class="cmn-button"> Read More </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-campionship23.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 5<sup>th</sup> & 7<sup>th</sup> May 2023</span>
                      </div>
                      <h3 class="card-title">Maharastra State Under 09 Open & Girls Selection Chess Championship
                        2023</h3>
                      <!-- <p class="card-text">Chess Association on Nagpur has the honour to invite all Chess Players from
                        Maharashtra</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-championship2023" class="cmn-button"> Read More </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-23.jpg"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 19<sup>th</sup> March 2023</span>
                      </div>
                      <h3 class="card-title">Tournament Report of GH Raisoni Memorial Bhandara District Chess
                        Tournament 2023</h3>
                      <!-- <p class="card-text">GH Raisoni Memorial Bhandara District level chess tournament concluded at
                        Lakhni.</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-tournament-bhandara" class="cmn-button"> Read More </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-1.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 19<sup>th</sup> March 2023</span>
                      </div>
                      <h3 class="card-title">Nagpur District Under 17 Open &amp; Girls Selection Chess Championship
                        2023</h3>
                      <!-- <p class="card-text">Arush Chitre &amp; Shraddha Bajaj wins the Competition</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-tournament23" class="cmn-button">Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-1.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 19<sup>th</sup>- 20<sup>th</sup> March 2022</span>
                      </div>
                      <h3 class="card-title">Maharashtra State under 12 Selection Open & Girls Chess Competition
                      </h3>
                      <!-- <p class="card-text">The Tournament was inaugurated by Shri. Girish Vyas</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-competition" class="cmn-button">Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-3.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> January 2023</span>
                      </div>
                      <h3 class="card-title">Employee Sports & Cultural Meet</h3>
                      <!-- <p class="card-text">G H Raisoni Sports and Cultural Foundation organizing Raisoni Group of -->
                      <!-- Institution's Employee</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/employee-sport-meet" class="cmn-button"> Read More </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card border-light shadow-soft">
                    <div class="card-header shadow-inset image-effect-1">
                      <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/com-6.webp"
                        class="card-img-top rounded" alt="GHRSCF" />
                    </div>
                    <div class="card-body">
                      <div class="event-date">
                        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/calendar.png"
                          alt="GHRSCF" />
                        <span> 2020</span>
                      </div>

                      <h3 class="card-title">Fide Chess Competition</h3>
                      <!-- <p class="card-text">It is a long established fact that a reader will be distracted by the -->
                      <!-- readable content of a page layout.</p> -->
                      <div class="d-flex justify-content-between">
                        <a routerLink="/chess-fest" class="cmn-button">Read More</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
